import { useState } from "react";
import Navigation from "../../components/Navigation";
import SideBar from "../../components/SideBar";
import Footer from "../../components/Footer";
import LogOutModal from "../../components/modals/LogOutModal";
import ContactUsModal from "../../components/modals/ContactUsModal";

const FAQs = () => {
  const [isLogOutModalOpen, setIsLogOutModalOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleLogOutModal = () => {
    setIsLogOutModalOpen(!isLogOutModalOpen);
  };

  const toggleContactUsModal = () => {
    setIsContactUsModalOpen(!isContactUsModalOpen);
  };

  const pageTitle = "FAQ";
  const breadcrumbs = [{ text: "Home", link: "/" }, { text: "FAQ" }];

  const faqItems = [
    {
      question: "How can I reset my password?",
      answer:
        "To reset your password, go to the login page and click on the 'Forgot password' link. Enter the email address associated with your account, and you will receive an email with instructions on how to reset your password. Follow the instructions in the email to create a new password.",
    },
    {
      question: "How can I contact customer support?",
      answer:
        "You can contact our customer support team through various channels. You can call our toll-free number 5055, send an email to info@accessbank.com.lr, or use the live chat feature on our website during business hours.",
    },
    {
      question: "How do I update my profile information?",
      answer:
        "To update your profile information, log in to your account and navigate to the 'Profile' or 'Account Settings' section. Here, you can edit your personal details, contact information, and preferences. Remember to save your changes before leaving the page.",
    },
    {
      question: "Is online banking secure?",
      answer:
        "Yes, we use industry-standard SSL encryption to protect your data. We also implement multi-factor authentication and regular security updates to ensure the safety of your information.",
    },
    {
      question: "How do I set up a recurring transfer?",
      answer:
        "To set up a recurring transfer, go to the 'Transfers' section, select 'Recurring Transfer', choose the source and destination accounts, enter the amount and frequency, and confirm the details.",
    },
  ];

  const toggleQuestion = (index) => {
    if (activeQuestion === index) {
      setActiveQuestion(null);
    } else {
      setActiveQuestion(index);
    }
  };

  return (
    <div className="m-0 font-sans antialiased font-normal text-base leading-default bg-gray-50 text-slate-500">
      <SideBar
        options={{ toggleLogOutModal, toggleContactUsModal }}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />

      <main className="ease-soft-in-out xl:ml-68.5 relative h-full max-h-screen rounded-xl transition-all duration-200">
        <Navigation
          pageTitle={pageTitle}
          breadcrumbs={breadcrumbs}
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        <div className="w-full px-6 py-6 mx-auto">
          <div className="flex flex-wrap -mx-3">
            <div className="flex-none w-full max-w-full px-3">
              <div className="relative flex flex-col min-w-0 mb-6 break-words bg-white border-0 border-transparent border-solid shadow-soft-xl rounded-2xl bg-clip-border">
                <div className="p-6 pb-0 mb-0 bg-white border-b-0 border-b-solid rounded-t-2xl border-b-transparent">
                  <div className="flex justify-between items-center">
                    <div>
                      <h6 className="text-2xl font-bold mb-2">
                        Frequently Asked Questions
                      </h6>
                      <p className="text-sm text-gray-600">
                        Find answers to common queries below
                      </p>
                    </div>
                    <div className="flex items-center">
                      <div className="mr-4">
                        <h2 className="text-lg font-semibold">Need Help?</h2>
                        <p className="text-sm text-gray-600">
                          We're here to assist you with any inquiries!
                        </p>
                      </div>
                      <button
                        className="bg-primary text-white px-6 py-2 rounded-full hover:bg-primary-dark transition-colors duration-300"
                        onClick={() => setIsContactUsModalOpen(true)}
                      >
                        Contact us
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex-auto px-0 pt-0 mt-5 pb-2">
                  <div className="p-6">
                    {faqItems.map((item, index) => (
                      <div
                        key={index}
                        className="mb-4 border-b border-gray-200 pb-4"
                      >
                        <button
                          className="flex justify-between items-center w-full text-left"
                          onClick={() => toggleQuestion(index)}
                        >
                          <h3 className="text-lg font-semibold text-primary-dark">
                            {item.question}
                          </h3>
                          <span className="text-2xl">
                            {activeQuestion === index ? "−" : "+"}
                          </span>
                        </button>
                        {activeQuestion === index && (
                          <p className="text-secondary-dark mt-2">
                            {item.answer}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </main>
      <LogOutModal
        isOpen={isLogOutModalOpen}
        setIsOpen={setIsLogOutModalOpen}
      />
      <ContactUsModal
        isOpen={isContactUsModalOpen}
        setIsOpen={setIsContactUsModalOpen}
      />
    </div>
  );
};

export default FAQs;
